var noConflict = {
  exports: {}
};

export { noConflict as n };
//# sourceMappingURL=no-conflict.js.map
